import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Branded launch screen — plays once per app launch, only when running as an
// installed app (standalone display mode). The manifest's background_color +
// maskable icon already brand the OS-level splash; this is the in-app strike.
const SLOGAN = "NO VENOM NEEDED ~ JUST PURE PRESSURE.";

export const AppSplash = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.matchMedia("(display-mode: window-controls-overlay)").matches ||
      window.navigator.standalone === true;
    if (!standalone) return;
    setShow(true);
    const t = setTimeout(() => setShow(false), 2400);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="fixed inset-0 z-[100] bg-obsidian flex flex-col items-center justify-center"
          data-testid="app-splash"
          aria-hidden="true"
        >
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(57,255,20,0.08),transparent_55%)]" />
          <motion.img
            src="/logo-coin.png"
            alt=""
            initial={{ scale: 0.2, rotate: -160, opacity: 0 }}
            animate={{ scale: [0.2, 1.08, 1], rotate: [-160, 8, 0], opacity: [0, 1, 1] }}
            transition={{ duration: 1.1, times: [0, 0.75, 1], ease: "easeOut" }}
            className="w-32 h-32 sm:w-40 sm:h-40 drop-shadow-[0_0_45px_rgba(57,255,20,0.4)]"
          />
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.6 }}
            className="mt-8 font-display text-sm sm:text-base font-bold tracking-[0.2em] text-white text-center px-6"
          >
            DGE<span className="text-venom">™</span>
          </motion.p>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2, duration: 0.7 }}
            className="mt-3 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.25em] text-venom/90 text-center px-6"
          >
            {SLOGAN}
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
